import { ZipcodeBulkUpsertGuard } from './zipcode-bulk-upsert.guard';

export const guards: any[] = [ZipcodeBulkUpsertGuard];

export * from './zipcode-bulk-upsert.guard';